import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { Event } from '@ifeng-fe/ui_base';
import Ad, { handleAd } from '@ifeng-fe/ui_pc_ad';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Tabs from './tabs';
import TabPane from './tabPane';
import ContentList from './contentList';
// import Chip from 'Chip';
// import Iframe from '@src/pc/hk/layout/components/iframe';
import NewsList from '../../../studio/layout/newsList';

class TabBox extends React.Component {
    static propTypes = {
        content: PropTypes.object,
        headline: PropTypes.array,
        allDayNews: PropTypes.object,
    };

    state = {
        insertArr: [],
        replaceArr: [],
        adFn: null,
        activeIndex: 0,
        selected: true,
    };

    event = new Event();

    insert = (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            this.setState({
                insertArr,
                replaceArr,
                adFn,
                activeIndex: this.activeIndex,
            });
        }

        return;
    };

    adInit = async (index, len) => {
        this.activeIndex = index;

        if (!(this.event.events && this.event.events.init)) {
            try {
                const { infoAd } = this.props.content;
                const callback = await handleAd(infoAd);

                callback(infoAd.data, this.event, this.insert);
            } catch (e) {
                console.error(e);
            }
        }

        try {
            this.event.trigger('init', { index, len });
        } catch (e) {
            console.error(e);
        }
    };

    handleSelected = () => {
        const { selected } = this.state;

        this.setState({ selected: !selected });
    };

    /**
     * 渲染组件
     */
    render() {
        const { insertArr, replaceArr, adFn, activeIndex, selected } = this.state;
        const {
            content: { infoTitle, hardAd, liveLogo },
            content,
            headline,
            allDayNews,
        } = this.props;

        return (
            <div className={styles.info}>
                <Tabs>
                    {infoTitle.map((item, index) => (
                        <TabPane key={index} tab={item.title}>
                            {/* <div style={{ display: index === infoTitle.length - 1 ? 'block' : 'none' }}>
                                <Chip
                                    id="260408"
                                    type="struct"
                                    title="7X24小时"
                                    groupName="7X24小时"
                                    content={allDayNews}>
                                    <Iframe />
                                </Chip>
                                <div id="fiu_news" />
                            </div> */}
                            <div style={{ display: index === infoTitle.length - 1 ? 'block' : 'none' }}>
                                <NewsList />
                            </div>
                            <div style={{ display: index !== infoTitle.length - 1 ? 'block' : 'none' }}>
                                <ContentList
                                    headline={headline}
                                    index={index}
                                    activeIndex={activeIndex}
                                    dataKey={item.key}
                                    moreUrl={item.url}
                                    event={this.event}
                                    // adInit={this.adInit}
                                    insertArr={insertArr}
                                    replaceArr={replaceArr}
                                    // adFn={adFn}
                                />
                            </div>
                        </TabPane>
                    ))}
                </Tabs>
                {/* <NoSSR onSSR={<div className={styles.hardAd} />}>
                    <Ad content={hardAd} styleName={styles.hardAd} />
                </NoSSR> */}
            </div>
        );
    }
}

export default errorBoundary(TabBox);
